export const defaultLabels: Record<string, string> = {
  // Common / navigation
  'common.createRoom': 'Create room',
  'common.joinRoom': 'Join room',
  'common.events': 'Events',
  'common.venues': 'Venues',
  'common.about': 'About',
  'common.search': 'Search',
  'common.back': 'Back',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.loading': 'Loading...',
  'common.language': 'Language',

  // Footer
  'footer.getStarted': 'Get started',
  'footer.findEvents': 'Find events',
  'footer.more': 'More',
  'footer.instagram': 'Instagram',
  'footer.ready': 'Ready to sing?',
  'footer.createFirstRoom': 'Create your first room',
  'footer.copyright': '© {year} Karaokr',

  // Landing page
  'landing.hero.title': 'Sing your heart out',
  'landing.hero.subtitle': 'The fair queue for your karaoke night.',
  'landing.howItWorks.title': 'How it works',

  // Festival / Venues
  'festival.title': 'Karaoke events',
  'festival.searchPlaceholder': 'Search venues or cities',
  'festival.openToPublic': 'Open to public',
  'festival.private': 'Private',
  'festival.all': 'All',
  'festival.noEvents': 'No events found for the selected period.',
  'festival.dateFilter.all': 'All',
  'festival.dateFilter.thisWeek': 'This week',
  'festival.dateFilter.today': 'Today',
  'festival.dateFilter.tomorrow': 'Tomorrow',
  'festival.dateFilter.weekend': 'This weekend',
  'festival.dateFilter.month': 'This month',
  'venues.title': 'Karaoke venues',
  'venues.loadMore': 'Load more places',

  // Event detail
  'event.recurring': 'Recurring',
  'event.happeningNow': 'Happening now',
  'event.price': 'Price',
  'event.host': 'Hosted by {host}',
  'event.moreInfo': 'More info',
  'event.viewDetails': 'View details',
  'event.directions': 'Directions',
  'event.venue': 'Venue',
  'event.about': 'About',
  'event.noDescription': 'No description available.',
  'event.noVenue': 'No venue linked to this event.',
  'event.website': 'Website',
  'event.until': 'until {time}',
  'event.recurrence': 'Recurrence',
  'event.recurrencePattern': 'This event repeats {frequency}',
  'event.recurrenceDay': 'on {day}',
  'event.recurrenceUntil': 'until {date}',

  // New i18n keys added during component migration
  'common.light': 'light',
  'common.dark': 'dark',
  'common.themeToggle': 'Switch to {mode} mode',
  'common.clearSearch': 'Clear search',
  'common.verified': 'Verified',
  'common.saveVenue': 'Save venue',
  'common.call': 'Call',
  'common.guest': 'Guest',
  'common.menu': 'Open menu',
  'common.allow': 'Allow',
  'common.block': 'Block',
  'common.logOut': 'Log Out',
  'common.cancel': 'Cancel',
  'common.saving': 'Saving…',
  'common.displayName': 'Your display name',
  'common.displayNamePlaceholder': 'How others will see you',
  'common.yourName': 'Your name',
  'common.host': 'Host',
  'common.join': 'Join',
  'common.remove': 'Remove',
  'common.confirmRemove': 'Remove?',
  'common.close': 'Close',
  'common.skip': 'Skip',
  'common.or': 'or',
  'common.pause': 'Pause',
  'common.resume': 'Resume',
  'common.roomPassword': 'Room password',
  'common.switchToDarkMode': 'Switch to dark mode',
  'common.switchToLightMode': 'Switch to light mode',
  'nav.festival': 'Festival',
  'nav.themeToggle': 'Switch to {mode} mode',
  'about.errorLoad': 'Failed to load content',
  'about.contentNotFound': 'Content not found',
  'cms.errorLoad': 'Failed to load content',
  'cms.contentNotFound': 'Content not found',
  'common.terms': 'Terms of Use',
  'common.privacy': 'Privacy Policy',
  'footer.legal': 'Legal',
  'landing.features.stageMode.title': 'Stage mode',
  'landing.features.stageMode.description': 'Full-screen YouTube Player with countdown, live reactions, and a leaderboard for the best performances.',
  'landing.features.liveQueue.title': 'Live queue control',
  'landing.features.liveQueue.description': 'Reorder, skip, or step aside singers in real-time. The fair queue keeps the party moving.',
  'landing.features.instantSearch.title': 'Instant song search',
  'landing.features.instantSearch.description': 'Search YouTube and add songs to the queue in seconds. No setup, no friction.',
  'landing.steps.createRoom.title': 'Create the room',
  'landing.steps.createRoom.description': 'Set a name and a password if you want a private party.',
  'landing.steps.shareStage.title': 'Share the stage',
  'landing.steps.shareStage.description': 'Send the link. Everyone joins from their phone in seconds.',
  'landing.steps.takeMic.title': 'Take the mic',
  'landing.steps.takeMic.description': 'The queue rotates fairly. Your moment is coming.',
  'landing.hero.lead': 'Create a room, share the code, and let everyone take the mic.',
  'landing.hero.findEvents': 'Find karaoke events →',
  'landing.howItWorks.sectionTitle': 'Make it your moment',
  'landing.features.sectionTitle': 'Why Karaokr?',
  'landing.features.learnMore': 'Learn more',
  'landing.cta.title': 'Ready to host your karaoke night?',
  'landing.cta.description': 'Create a free room, invite your friends, and let the queue do the rest.',
  'landing.cta.primary': 'Create a room',
  'landing.cta.secondary': 'Find events',
  'landing.singlists.title': 'Singlists',
  'landing.singlists.description': 'Ready-made song collections to get the party started.',
  'landing.singlists.viewAll': 'View all singlists',
  'landing.hero.phrase.heartOut': 'heart out',
  'landing.hero.phrase.lungsOut': 'lungs out',
  'landing.hero.phrase.soulOut': 'soul out',
  'landing.hero.phrase.voiceOut': 'voice out',
  'landing.hero.phrase.worriesAway': 'worries away',
  'landing.hero.phrase.nightAway': 'night away',
  'landing.hero.connector': 'your',
  'festival.errorLoadingEvents': 'Error loading events',
  'festival.eventCount': '{count} event{suffix}{city}{date}',
  'festival.privateRooms': 'Private rooms',
  'festival.publicAndPrivate': 'Public & private',
  'festival.searchEventsPlaceholder': 'Search events, venues or cities',
  'venues.cityTitle': 'Karaoke venues in {city}',
  'venues.errorLoadingData': 'Error loading data',
  'venues.loadError': 'Failed to load venues',
  'venues.loading': 'Loading venues…',
  'venues.new': 'New',
  'venues.noCityVenues': 'No karaoke venues found in this city.',
  'venues.noMatch': 'No approved venues match your filters.',
  'venues.noMatchInCity': 'No venues match your filters in {city}.',
  'venues.placeCount': '{count} place{suffix}',
  'venues.saveVenue': 'Save venue',
  'venues.verified': 'Verified',
  'venues.viewAll': 'View all venues',
  'venues.viewMockPage': 'View mock page',
  'event.loading': 'Loading event…',
  'event.errorLoading': 'Error loading event',
  'event.notFound': 'Event not found',
  'event.backToEvents': 'Back to events',
  'event.hostLabel': 'Host: {host}',
  'venue.privateRooms': 'Private rooms',
  'venue.publicAndPrivate': 'Public & private',
  'venue.slugRequired': 'Venue slug is required',
  'venue.errorLoading': 'Error loading venue',
  'venue.loading': 'Loading venue…',
  'venue.notFound': 'Venue not found',
  'venue.backToVenues': 'Back to venues',
  'venue.openingHours': 'Opening hours',
  'venue.upcomingEvents': 'Upcoming events',
  'venue.noUpcomingEvents': 'No upcoming events.',
  'venue.new': 'New',
  'mock.eventNotFound': 'Mock event not found.',
  'mock.venueNotFound': 'Mock venue not found.',
  'mock.noVenuesMatch': 'No venues match your search.',
  'mock.noEventsMatch': 'No mock events match the selected period.',
  'room.host': 'Host',
  'room.singer': 'Singer',
  'room.entryCode': 'Entry code',
  'codeRedirect.notFoundHint': 'This code does not match any active room. Check the 4 digits and try again.',
  'room.queueOpen': 'Queue Open',
  'room.queueClosed': 'Queue Closed',
  'room.settings': 'Settings',
  'room.notificationsOn': 'Notifications on',
  'room.notificationsOff': 'Notifications off',
  'room.leaveRoom': 'Leave Room',
  'room.endedTitle': 'Room Ended',
  'room.endedMessage': 'The host has ended this room. Thanks for singing!',
  'room.joinAnotherRoom': 'Join another room',
  'room.joining': 'Joining room…',
  'room.emptyQueue': 'Queue is empty. Add the first song or drop a moment!',
  'room.hostControls': 'Host controls',
  'room.countdownLabel': 'Countdown',
  'room.nowLive': 'Now live',
  'room.timeLeft': 'Time left',
  'room.playNext': '▶ Play Next',
  'room.startEvent': '▶ Start Event',
  'room.startEventHint': 'The queue only starts moving after you press Start Event',
  'room.play': '▶ Play',
  'room.pause': '⏸ Pause',
  'room.showQR': 'Show QR',
  'room.hideQR': 'Hide QR',
  'room.pauseCountdown': '⏸ Pause Countdown',
  'room.resumeCountdown': '▶ Resume Countdown',
  'room.skipCountdown': 'Skip Countdown',
  'room.add10s': '+10s',
  'room.add30s': '+30s',
  'room.restart': 'Restart',
  'room.mute': 'Mute',
  'room.showLeaderboard': 'Show Leaderboard',
  'room.stepAside': 'Step Aside',
  'room.endMoment': 'End moment',
  'room.reactionsTitle': 'Reactions',
  'room.connectedSingers': 'Connected singers',
  'room.noSingers': 'No singers connected.',
  'room.canAddSongs': 'Can add songs',
  'room.cannotAddSongs': 'Cannot add songs',
  'room.kick': 'Kick',
  'room.moments': 'Moments',
  'room.dragToQueue': 'Drag to the queue',
  'room.addToQueueEnd': 'Add to queue end',
  'room.addSong': 'Add song',
  'room.settingsTitle': 'Room Settings',
  'room.maxSongsPerSinger': 'Max songs per singer',
  'room.countdownSeconds': 'Countdown (seconds)',
  'room.roomPassword': 'Room password',
  'room.passwordPlaceholder': 'Leave empty for public room',
  'room.showPassword': 'Show password',
  'room.hidePassword': 'Hide password',
  'room.passwordProtectedHint': 'This room is currently password-protected.',
  'room.stagePasswordLabel': 'Stage password',
  'room.stagePasswordPlaceholder': '4 characters, leave empty to disable',
  'room.showStagePassword': 'Show stage password',
  'room.hideStagePassword': 'Hide stage password',
  'room.stageProtectedHint': 'The Stage is currently password-protected.',
  'room.queueVisibility': 'Queue visibility',
  'room.showFullQueue': 'Show full queue to singers',
  'room.saveChanges': 'Save changes',
  'room.stagePasswordError': 'Stage password must be at least 4 characters.',
  'room.settingsSaved': 'Settings saved.',
  'room.hideAvatars': 'Avatars on the Stage',
  'room.hideAvatarsCheckbox': 'Hide singer avatars on the Stage',
  'room.hideAvatarsHint': 'When hidden, the big screen shows no avatars at all — not even initials.',
  'room.playlists.button': 'Room playlists',
  'room.playlists.title': 'Room playlists',
  'room.playlists.hint': 'Only the playlists you add here are shown to singers in this room.',
  'room.playlists.counter': '{count}/{max} playlists',
  'room.playlists.empty': 'No playlists yet. Add one from the available list below.',
  'room.playlists.songCount': '{count} songs',
  'room.playlists.add': 'Add',
  'room.playlists.remove': 'Remove',
  'room.playlists.showAvailable': 'Show available playlists',
  'room.playlists.hideAvailable': 'Hide available playlists',
  'room.playlists.error': 'Could not update playlists. Try again.',
  'room.playlists.loginRequired': 'Log in to manage room playlists.',
  'room.endRoom': 'End Room',
  'room.endRoomConfirmTitle': 'End this room?',
  'room.endRoomConfirmMessage': 'All singers will be kicked and the room will close.',
  'room.confirmEndRoom': 'Yes, End Room',
  'room.addToQueue': 'Add to Queue',
  'room.error.notFound': 'Room not found.',
  'room.error.ended': 'This room has ended.',
  'room.error.serviceUnreachable': 'Could not reach the room service.',
  'room.error.googleLoginFailed': 'Google login failed.',
  'room.error.googleLoginTryAgain': 'Google login failed. Please try again.',
  'console.createRoom.heroTitle': 'Start your karaoke night',
  'console.createRoom.heroSubtitle': 'Create a room in seconds, share the code, and let everyone queue their songs.',
  'console.createRoom.checkingSession': 'Checking your session…',
  'console.createRoom.signInPrompt': 'Sign in with Google to create and host a room. Joining a room as a guest still works without an account.',
  'console.createRoom.hostingAs': 'Hosting as {name}',
  'console.createRoom.roomNameLabel': 'Room name',
  'console.createRoom.roomNamePlaceholder': 'e.g. friday-karaoke',
  'console.createRoom.maxSongsLabel': 'Max songs per singer',
  'console.createRoom.passwordLabel': 'Password (optional)',
  'console.createRoom.passwordPlaceholder': 'Leave empty for public room',
  'console.joinRoom.heroTitle': 'Join the party',
  'console.joinRoom.heroSubtitle': 'Enter the room code and your name to start singing with friends.',
  'console.joinRoom.roomCodeLabel': 'Room code',
  'console.joinRoom.roomCodePlaceholder': 'e.g. 4821 or friday-karaoke-2atn',
  'console.joinRoom.passwordLabel': 'Password (if required)',
  'console.joinRoom.activeRoomsTitle': 'Active Rooms',
  'console.joinRoom.noActiveRooms': 'No active rooms right now.',
  'console.joinRoom.activeRoomMeta': '{count} singers{protected}{venue}',
  'console.joinRoom.passwordProtected': 'Password protected',
  'console.joinRoom.checkingRoom': 'Checking room...',
  'console.joinRoom.hostAccessTitle': 'Host Access',
  'console.joinRoom.joinStageTitle': 'Join the Stage',
  'console.joinRoom.roomLabel': 'Room: {roomId}',
  'console.joinRoom.roomNotFoundCreate': 'This room does not exist yet. Sign in with Google to create it.',
  'console.joinRoom.signInToManage': 'Sign in with Google to manage this room.',
  'console.joinRoom.notHostButton': 'I am a singer, not the host',
  'console.joinRoom.passwordRequiredPlaceholder': 'Required to enter',
  'console.joinRoom.joinAsSingerButton': 'Join as Singer',
  'console.joinRoom.joiningRoom': 'Joining the room…',
  'console.joinRoom.googleOptionalHint': 'Google login is optional for singers and unlocks favorites and history.',
  'console.joinRoom.orGuest': 'or continue as a guest',
  'console.joinRoom.intro': 'Enter your details to join {room}',
  'console.joinRoom.roomPasswordLabel': 'Room password',
  'console.joinRoom.roomPasswordPlaceholder': 'Enter password',
  'singer.joinRoom.carousel.hostTitle': 'Host amazing events',
  'singer.joinRoom.carousel.singDesc': 'Join the queue, pick your favorite songs, and take the mic. Karaokr makes every event unforgettable.',
  'singer.joinRoom.carousel.hostDesc': 'Create a room, manage the queue, and let the big screen handle the show. Easy, fun, and social.',
  'singer.joinRoom.carousel.slideLabel': 'Slide {number}',
  'singer.queue.onStage': 'On stage',
  'singer.queue.moveUp': 'Move up',
  'singer.queue.moveDown': 'Move down',
  'singer.queue.openInYouTube': 'Open in YouTube',
  'singer.queue.removeMoment': 'Remove moment',
  'singer.queue.saveSong': 'Save song',
  'singer.queue.saved': 'Saved',
  'singer.queue.addToFavorites': 'Save to favorites',
  'singer.queue.removeFromFavorites': 'Remove from favorites',
  'singer.queue.addedBy': 'Added by {name}',
  'singer.queue.momentFallback': 'Moment',
  'singer.addSong': 'Add song',
  'singer.addToQueue': 'Add to Queue',
  'singer.atLimitHint': "You've reached the limit of {max} songs. Wait for one to play before adding more.",
  'singer.blockedHint': "You've been temporarily blocked from adding songs.",
  'singer.dragToReorder': 'Drag to reorder your songs.',
  'singer.emptyQueue': 'Queue is empty. Add the first song!',
  'singer.goToHostPage': 'Go to Host Page',
  'singer.guest': 'Guest',
  'singer.addFailed': 'Could not add the song. Please try again.',
  'singer.hostRedirectHint': 'Use the host page to manage this room.',
  'singer.hostRedirectTitle': 'You are the host',
  'singer.leaveRoom': 'Leave Room',
  'singer.leaveRoomConfirmTitle': 'Leave this room?',
  'singer.leaveRoomConfirmMessage': 'Leaving will remove all your songs from the queue.',
  'singer.confirmLeaveRoom': 'Leave & Remove My Songs',
  'singer.onStage': 'On Stage',
  'singer.openMenu': 'Open menu',
  'singer.profile': 'Profile',
  'singer.queueClosed': 'Queue Closed',
  'singer.queueOpen': 'Queue Open',
  'singer.queueTitle': 'Queue',
  'singer.reaction.heart': 'Heart',
  'singer.reaction.like': 'Like',
  'singer.reaction.star': 'Star',
  'singer.stagePrefs.title': 'Stage preferences',
  'singer.stagePrefs.displayName': 'Name shown on the Stage',
  'singer.stagePrefs.nameHint': 'Leave empty to use your Google name.',
  'singer.stagePrefs.showAvatar': 'Show my avatar on the Stage',
  'singer.stagePrefs.showAvatarHint': 'Turn off to hide your avatar everywhere on the big screen.',
  'singer.stagePrefs.error': 'Could not save. Try again.',
  'singer.singerRole': 'Singer',
  'singer.songsInQueueCount': 'You have {count} of {max} song{plural} in the queue.',
  'singer.waitForTurn': 'Wait for your turn. The host controls the stage.',
  'singer.waitTime': '≈ {time} until your turn',
  'singer.waitTimeShort': '≈ {time}',
  'singer.yourSongs': 'Your songs',
  'singer.yourSpot': 'Your spot',
  'profile.addToFavorites': 'Add to favorites',
  'profile.failedToLoadProfile': 'Failed to load profile',
  'profile.favorites': 'Favorites',
  'profile.guest': 'Guest',
  'profile.guestNote': 'Sign in with Google to save your favorites and history across events.',
  'profile.loadingProfile': 'Loading profile…',
  'profile.logOut': 'log out',
  'profile.next': 'Next →',
  'profile.noFavorites': 'No favorites yet. Tap the star on any song to save it here.',
  'profile.noFinishedEvents': 'No finished events yet.',
  'profile.noSongsSung': 'No songs sung yet. Join a room and take the mic!',
  'profile.pageOf': 'Page {page} of {totalPages}',
  'profile.prev': '← Prev',
  'profile.reactionsReceived': 'Reactions received',
  'profile.removeFromFavorites': 'Remove from favorites',
  'profile.songsSung': 'Songs sung',
  'profile.songsYouSang': 'Songs you sang',
  'search.add': 'Add',
  'search.artists': 'Artists',
  'search.forceYouTube': 'Search on YouTube',
  'search.addFavorite': 'Add favorite',
  'search.adding': 'Adding…',
  'search.addSongTitle': 'Add Song',
  'search.clearSearch': 'Clear search',
  'search.close': 'Close',
  'search.collapse': 'Collapse',
  'search.expand': 'Expand',
  'search.goToPlaylist': 'Go to singlist {n}',
  'search.noPlaylists': 'No singlists available for this event yet.',
  'search.noResults': 'No results. Try a different query.',
  'search.noSavedSongs': 'No saved songs yet.',
  'search.playlists': 'Singlists',
  'search.preview': 'Preview',
  'search.recentlyPlayed': 'Recently Played',
  'search.recentlyPlayedDescription': 'Songs you sang before',
  'search.removeFavorite': 'Remove favorite',
  'search.saved': 'Saved',
  'search.singerNamePlaceholder': 'Singer name',
  'search.yourFavorites': 'Your Favorites',
  'search.youtubePlaceholder': 'Search YouTube...',
  'search.youtubeSearchFailed': 'YouTube search failed',
  'search.error': 'YouTube search failed',
  'stage.title': 'Stage',
  'stage.live': 'Live',
  'stage.upNext': "You're up next: {song}",
  'bigpicture.stage.accessTitle': 'Stage access',
  'bigpicture.stage.passwordLead': 'Enter the 4-character Stage password for room {roomId}.',
  'bigpicture.stage.passwordRequired': 'Stage password required',
  'bigpicture.stage.enterButton': 'Enter Stage',
  'bigpicture.stage.tvAuthFailed': 'TV pairing expired or the Stage password changed. Generate a new code on the TV and pair again.',
  'tv.loadingCode': 'Loading…',
  'tv.welcome.en': 'welcome to',
  'tv.welcome.pt': 'bem-vindo ao',
  'tv.welcome.es': 'bienvenido a',
  'tv.welcome.fr': 'bienvenue à',
  'tv.welcome.it': 'benvenuto a',
  'tv.scanHint': 'Scan the QR code with your phone to connect this screen to an event',
  'tv.manualHint': 'or open karaokr on your phone and enter the code above',
  'tv.pairingFailed': 'Could not generate a pairing code. Retry on the TV.',
  'tv.connectingStage': 'Pairing accepted — starting the Stage…',
  'tv.youtubeSignIn': 'Sign in to YouTube first',
  'tv.youtubeSignInHint': 'The pop-up was blocked. Open accounts.google.com in this TV\'s browser, sign in to your Google account (pick the QR/phone option to skip typing with the remote), then come back here.',
  'tv.menu.theme': 'Theme',
  'tv.menu.themeDark': 'Dark',
  'tv.menu.themeLight': 'Light',
  'tv.menu.language': 'Language',
  'tv.menu.langEn': 'English',
  'tv.menu.langPt': 'Português',
  'tv.exitConfirm.title': 'Close Karaokr TV?',
  'tv.exitConfirm.subtitle': 'The Stage will stop on this screen.',
  'tv.exitConfirm.cancel': 'Keep watching',
  'tv.exitConfirm.close': 'Close app',
  'pair.loginTitle': 'Sign in to connect the TV',
  'pair.loginLead': 'Only the event host can connect a screen.',
  'pair.backToTv': 'Back to the TV screen',
  'pair.title': 'Connect a TV',
  'pair.lead': 'Enter the code shown on the TV screen and choose your event.',
  'pair.codeLabel': 'Code on the TV',
  'pair.eventLabel': 'Your event',
  'pair.noRooms': 'No active events found. Enter the room code manually below.',
  'pair.manualRoomPlaceholder': 'or enter the room code manually',
  'pair.stagePasswordLabel': 'Stage password (if the event has one)',
  'pair.stagePasswordPlaceholder': 'Optional',
  'pair.claiming': 'Connecting…',
  'pair.submit': 'Connect TV',
  'pair.successTitle': 'TV connected',
  'pair.successLead': 'The Stage for "{room}" will start on the TV in a moment.',
  'pair.openConsole': 'Open event console',
  'pair.pairAnother': 'Connect another TV',
  'pair.error.not_authenticated': 'Sign in again and retry.',
  'pair.error.invalid_code': 'Invalid or expired code. Check the code on the TV and try again.',
  'pair.error.room_not_found': 'Event not found or already ended.',
  'pair.error.not_host': 'Only the event host can connect a TV to this event.',
  'pair.error.wrong_stage_password': 'Wrong Stage password for this event.',
  'pair.error.screen_offline': 'The TV is no longer waiting for a code. Generate a new code on the TV and scan it again.',
  'pair.error.rate_limited': 'Too many attempts. Wait a moment and try again.',
  'pair.error.pairing_failed': 'Pairing failed. Try again.',
  'bigpicture.connecting': 'Connecting to {roomId}...',
  'bigpicture.moment.endNote': 'Thank you for singing! 🎤',
  'bigpicture.empty.title': 'The queue is empty',
  'bigpicture.empty.qrAlt': 'Join room QR code',
  'bigpicture.empty.qrHint': 'Scan to join the party',
  'bigpicture.waitingHost': 'The event starts soon — pick your songs while you wait!',
  'bigpicture.results.reactionTitle': 'Reaction Recap',
  'bigpicture.results.heart': 'Heart',
  'bigpicture.results.star': 'Star',
  'bigpicture.results.like': 'Like',
  'bigpicture.results.leaderboardTitle': 'Leaderboard',
  'bigpicture.qr.alt': 'Join room QR code',
  'bigpicture.qr.title': 'Scan to join',
  'bigpicture.qr.join': 'Join the room',
  'bigpicture.tapToPlay.title': 'Tap to start',
  'bigpicture.tapToPlay.hint': 'Your browser blocked autoplay',
  'bigpicture.videoBlocked.title': 'YouTube blocked playback on this device',
  'bigpicture.videoBlocked.hint': 'The button below opens the Google sign-in for YouTube on this TV (pick the QR/phone option to skip typing with the remote). After signing in, tap here to retry — or skip this song from your phone.',
  'bigpicture.intro.upNext': 'Up next',
  'bigpicture.nextQueue.label': 'next in queue',
  'bigpicture.nextQueue.nextLabel': 'Next',
  'bigpicture.nextQueue.nextMoment': 'Next: {title}',
  'bigpicture.leaderboard.title': 'Leaderboard',
  'bigpicture.dev.endMoment': 'End moment',
  'bigpicture.dev.intro': 'Intro',
  'bigpicture.dev.break': 'Break',
  'bigpicture.dev.showQR': 'Show QR',
  'bigpicture.dev.hideQR': 'Hide QR',
  'bigpicture.dev.leaderboard': 'Leaderboard',
  'bigpicture.dev.hideLeaderboard': 'Hide Leaderboard',
  'bigpicture.dev.endVideo': 'End video',
  'bigpicture.moment.introTitle': 'Welcome!',
  'bigpicture.moment.introDesc': 'Get ready to sing your heart out.',
  'bigpicture.moment.breakTitle': 'Short break',
  'bigpicture.moment.breakDesc': 'Bathroom break. Back in 5.',
  'bigpicture.moment.endTitle': 'Goodnight!',
  'bigpicture.moment.endDesc': 'Thanks for an amazing night!',
  'ui.dismiss': 'Dismiss',
  'reaction.send': 'Send {type}',
  'mock.favorites': 'Favorites',
  'mock.favoriteSongFallback': 'Favorite song',
  'mock.hideLeaderboard': 'Hide Leaderboard',
  'mock.hideQR': 'Hide QR',
  'mock.hostControls': 'Host controls',
  'mock.hostRole': 'Host',
  'mock.intro': 'Intro',
  'mock.kick': 'Kick',
  'mock.leaderboard': 'Leaderboard',
  'mock.leaveRoom': 'Leave Room',
  'mock.leaveTestRoom': 'Leave Test Room',
  'mock.loadingMockProfile': 'Loading mock profile…',
  'mock.maxSongsPerSinger': 'Max songs per singer',
  'mock.mockAddSongTitle': 'Mock Add Song',
  'mock.mockMode': 'MOCK MODE',
  'mock.moment.break.description': 'Bathroom break. Back in 5.',
  'mock.moment.break.title': 'Short break',
  'mock.moment.end.description': 'Thanks for an amazing night!',
  'mock.moment.end.title': 'Goodnight!',
  'mock.moment.intro.description': 'Get ready to sing your heart out.',
  'mock.moment.intro.title': 'Welcome!',
  'mock.moment.thanks.description': 'Thanks for singing!',
  'mock.moment.thanks.title': 'Thank you',
  'mock.moments': 'Moments',
  'mock.more': 'More',
  'mock.mute': 'Mute',
  'mock.next': 'Next →',
  'mock.nextInQueue': 'next in queue',
  'mock.noFavorites': 'No favorites yet.',
  'mock.noFinishedEvents': 'No finished events yet.',
  'mock.noSongsSung': 'No songs sung yet.',
  'mock.notificationsOff': 'Notifications off',
  'mock.openMenu': 'Open menu',
  'mock.pageOf': 'Page {page} of {totalPages}',
  'mock.pause': 'Pause',
  'mock.pauseCountdown': 'Pause Countdown',
  'mock.play': 'Play',
  'mock.playNext': 'Play Next',
  'mock.playlist1': 'Friday Night Hits',
  'mock.playlist2': '90s Classics',
  'mock.playlists': 'Singlists',
  'mock.prev': '← Prev',
  'mock.qrCodeAlt': 'Join room QR code',
  'mock.queueOpen': 'Queue Open',
  'mock.reaction.heart': 'Heart',
  'mock.reaction.like': 'Like',
  'mock.reaction.star': 'Star',
  'mock.reactionRecap': 'Reaction Recap',
  'mock.reactionsReceived': 'Reactions received',
  'mock.removeFromFavorites': 'Remove from favorites',
  'mock.restart': 'Restart',
  'mock.resume': 'Resume',
  'mock.resumeCountdown': 'Resume Countdown',
  'mock.roomSettings': 'Room Settings',
  'mock.saved': 'Saved',
  'mock.scanToJoin': 'Scan to join',
  'mock.searchPlaceholder': 'Search songs...',
  'mock.settings': 'Settings',
  'mock.showLeaderboard': 'Show Leaderboard',
  'mock.showQR': 'Show QR',
  'mock.simulateKeyboardClosed': 'Simulate keyboard closed (blur)',
  'mock.simulateKeyboardOpen': 'Simulate keyboard open (focus)',
  'mock.singerRole': 'Singer',
  'mock.skipCountdown': 'Skip Countdown',
  'mock.songsInQueueCount': 'You have {count} song{plural} in the queue.',
  'mock.songsSung': 'Songs sung',
  'mock.songsYouSang': 'Songs you sang',
  'mock.stage': 'Stage',
  'mock.stepAside': 'Step Aside',
  'mock.upNext': 'Up next',
  'mock.viewRealProfile': 'View Real Profile',
  'mock.waitForTurn': 'Wait for your turn. The host controls the stage.',
  'mock.yesEndRoom': 'Yes, End Room',
  'mock.yourSpot': 'Your spot',

  // Duet invites
  'duet.inviteTitle': 'Invite a singer',
  'duet.invite': 'Invite',
  'duet.noSingers': 'No singers available right now.',
  'duet.receivedTitle': '{name} invited you to sing together',
  'duet.unknownSong': 'a song',
  'duet.accept': 'Accept',
  'duet.decline': 'Decline',
  'duet.result.accepted': '{name} accepted your duet invite',
  'duet.result.declined': '{name} declined your duet invite',
  'duet.result.expired': 'Your duet invite for {name} expired',
  'duet.result.failed': 'Could not invite {name}. Try again.',

  // Turn notifications (you're next / you're on)
  'turn.next.title': "You're next!",
  'turn.next.hint': 'Warm up — your song comes up after this one',
  'turn.on.title': "You're on!",
  'turn.on.hint': 'Head to the stage!',

  // Consent / GDPR
  'consent.agreeLabel': 'I agree to the',
  'consent.joinAgreeLabel': 'By joining, you agree to the',
  'consent.implicitNoticeLead': 'By joining or adding songs, you agree to our',
  'consent.title': 'Before you start',
  'consent.intro': 'We only collect the data we need to make your karaoke night work. You are in control.',
  'consent.authTitle': 'Authentication data',
  'consent.authDescription': 'Your name, email and avatar are used to identify you and sync your favorites and history across sessions.',
  'consent.activityTitle': 'Room activity',
  'consent.activityDescription': 'Your name and avatar are shown in the queue of the rooms you join. Songs you add, reactions and favorites are stored so the queue and leaderboard work.',
  'consent.locationTitle': 'Location',
  'consent.locationDescription': 'We may use your approximate city to show nearby karaoke venues and events.',
  'consent.required': 'Required',
  'consent.optional': 'Optional',
  'consent.acceptTerms': 'I agree to the',
  'consent.termsLink': 'Terms of Use',
  'consent.privacyLink': 'Privacy Policy',
  'consent.and': 'and',
  'consent.acceptData': 'I accept the processing of my personal data for the purposes described above.',
  'consent.acceptLocation': 'I agree to share my approximate location.',
  'consent.acceptGoogle': 'Continue with Google',
  'consent.acceptGuest': 'Continue as guest',
  'consent.continueAsGuest': 'Use a different method',
  'consent.useEphemeralGuest': 'Continue without saving data',
};

export function getDefaultLabel(key: string): string {
  return defaultLabels[key] ?? key;
}
